import { MutationTree } from "vuex";
import { HomeState } from "../types";

const mutations: MutationTree<HomeState> = {
  setPromptForCancel(state, isCancelling: boolean) {
    state.isPromptingForCancel = isCancelling;
  },
};

export default mutations;
